import React from "react";
import PropTypes from "prop-types";
//Limitless imports
import { validateSignInForm } from "../../../utils/validators/SignInFormValidator";
import { useSignInContext } from "../../../hooks/sign-in/SignInContext";
import { useAuthenticationContext } from "../../../hooks/authentication/AuthenticationContext";
import { log as pilog } from "@limitless/common/utils";
const SignInForm = ({
  children,
  redirectMessage,
  onSignInSuccess = () => null,
  initialEmail
}) => {
  const {
    signIn,
    loading,
    password,
    setPassword,
    email,
    setEmail
  } = useSignInContext();
  const {
    auth: {
      errorMessage
    },
    clearAuthError
  } = useAuthenticationContext();
  const log = pilog.getLogger("SignInForm");
  log.debug(errorMessage);
  React.useEffect(() => {
    if (initialEmail) {
      setEmail({
        value: initialEmail,
        pristine: false
      });
    }
  }, [initialEmail]);
  const onFormSubmit = storageCallback => {
    signIn(onSignInSuccess, storageCallback);
  };
  const {
    fieldErrors,
    isFormInvalid,
    userErrorMessage
  } = validateSignInForm({
    email,
    password
  }, errorMessage, redirectMessage, true);
  return children({
    email,
    password,
    fieldErrors,
    isFormInvalid,
    userErrorMessage,
    onEmailChange: value => setEmail({
      value,
      pristine: false
    }),
    onPasswordChange: value => setPassword({
      value,
      pristine: false
    }),
    onFormSubmit,
    loading,
    clearAuthError
  });
};
export default SignInForm;
SignInForm.propTypes = {
  children: PropTypes.func.isRequired,
  redirectMessage: PropTypes.string,
  onSignInSuccess: PropTypes.func
};